import { useFormikContext } from "formik"
import ButtonGroupBuyAdd from "./buttons-buy-add"

type Props = {
  businessName?: string
  isDisabledButton?: boolean
}

const ReviewCheckoutButtons = (props: Props) => {
  const form = useFormikContext()
  const { businessName, isDisabledButton } = props;

  return (
    <div className="mb-6">
      <ButtonGroupBuyAdd businessName={businessName} isDisabledButton={isDisabledButton} />
    </div>
  )
}

export default ReviewCheckoutButtons
